import { Input, Label } from "../components/UI";
import { FileText } from "lucide-react";
import { NewPill } from "../components/NewPill";

/** Staff profile section that marks a user as a prescriber with the credentials printed on prescriptions. */
export function PrescriberFields({ form, setForm }) {
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return (
    <div className="col-span-2 rounded-xl border border-[#F1E8DA] bg-[#FDFCF8] p-4" data-testid="user-prescriber-section">
      <label className="flex cursor-pointer items-center gap-2 text-sm font-semibold text-[#3E2723]">
        <input type="checkbox" data-testid="user-is-prescriber" checked={!!form.is_prescriber} onChange={(e) => setForm({ ...form, is_prescriber: e.target.checked })} className="h-4 w-4 accent-[#4E342E]" />
        Prescriber (can create and sign prescriptions) <NewPill feature="prescriber-profile" />
      </label>
      <p className="mt-1 text-xs text-[#7B6157]">NPI and DEA number are required before this person can sign. They print on every prescription.</p>
      {form.is_prescriber && (
        <div className="mt-3 grid grid-cols-2 gap-3">
          <div><Label>Credentials</Label><Input data-testid="user-prescriber-credentials" value={form.prescriber_credentials} onChange={set("prescriber_credentials")} placeholder="MD, PMHNP-BC" /></div>
          <div><Label>State license number</Label><Input data-testid="user-prescriber-license" value={form.prescriber_license} onChange={set("prescriber_license")} placeholder="Optional" /></div>
          <div><Label>NPI (10 digits)</Label><Input data-testid="user-prescriber-npi" value={form.prescriber_npi} onChange={set("prescriber_npi")} inputMode="numeric" maxLength={10} /></div>
          <div><Label>DEA number</Label><Input data-testid="user-prescriber-dea" value={form.prescriber_dea} onChange={(e) => setForm({ ...form, prescriber_dea: e.target.value.toUpperCase() })} maxLength={9} /></div>
        </div>
      )}
    </div>
  );
}

export function PrescriberChip({ u }) {
  if (!u.is_prescriber) return <span className="text-xs text-[#84675B]">-</span>;
  const ready = u.prescriber_npi && u.prescriber_dea;
  return (
    <span data-testid={`user-prescriber-${u.id}`} title={ready ? "Ready to sign" : "Missing NPI or DEA number"}
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold ${ready ? "bg-[#E8F5E9] text-[#2E7D32]" : "bg-[#FFF3E0] text-[#8D5A00]"}`}>
      <FileText size={11} /> {ready ? "Prescriber" : "Needs NPI/DEA"}
    </span>
  );
}
